import { Box, styled } from '@mui/joy'

export const CBox = styled(Box,
  {
    slot: 'root',
    name: 'CBox'
  }
)(() => ({
  display: 'flex',
  width: '100%',
  alignItems: 'center',
  flexDirection: 'column',
  justifyContent: 'center',
  textAlign: 'center'
}))